<div class="m-2">
  <kendo-label *ngIf="isLabelVisible()" [for]="getHiddenControlName()" [text]="getLabel()">
      <span *ngIf="isRequired()" class="required">*</span>
  </kendo-label>
  <kendo-maskedtextbox *ngIf="isControlVisible()" [id]="getControlName()" [name]="getControlName()" [(ngModel)]="inputValue"
    [required]="isRequired()" [mask]="getMask()" prompt=" " promptPlaceholder="" [maskValidation]="false">
  </kendo-maskedtextbox>
  <kendo-textbox *ngIf="isControlVisible()" class="hidden-input" [id]="getHiddenControlName()" [name]="getHiddenControlName()" [(ngModel)]="inputValue" [required]="isRequired()"
    [pattern]="getPattern()">
  </kendo-textbox>
  <div *ngIf="isControlVisible() && !isCustomValidationValid()">
    <kendo-formerror>{{getCustomValidationMessage()}}</kendo-formerror>
  </div>
</div>